import React, { useRef } from 'react';
import { useStore } from '../../store/useStore';
import { BarChart } from '../Charts';
import { useResizeObserver } from '../../hooks/useResizeObserver';

const PressureTracker = () => {
  const { longPressure, shortPressure } = useStore((state) => state.tickTally);
  const containerRef = useRef<HTMLDivElement>(null);
  const size = useResizeObserver(containerRef);

  return (
    <div ref={containerRef} style={{ width: '100%', height: '100%' }}>
      <BarChart size={size} data={[longPressure, shortPressure]} />
    </div>
  );
};
export { PressureTracker };
